import React from 'react';
import Popup from 'components/popups/popup';

// FIXME this component will be replaced in the near future by generic Popup component from Clarity (interface elements library)
export class PopupListing extends Popup {
    title() {
        return this.props.title;
    }

    content() {
        const {
            dangerous,
            superDangerous,
            content
        } = this.props;

        if (superDangerous) {
            return <div className='popup-listing-content'>{ content }</div>
        }
        return dangerous ? <div className={'popup-listing-content'} dangerouslySetInnerHTML={{ __html: content }}/> : <div className='popup-listing-content'>{ content }</div>
    }
}

PopupListing.defaultProps = {
    popupClassName: 'popup-listing',
    single: true,
    modal: true,
    classNames: ['no-animation']
};

export default PopupListing;
